import { animate, keyframes, style, animation } from '@angular/animations';

export const pulseUpdate = animation([
  animate(
    '1s',
    keyframes([
      style({ backgroundColor: '*', offset: 0 }),
      style({ backgroundColor: 'rgba(48, 180, 29, 0.25)', offset: 0.2 }),
      style({ backgroundColor: '*', offset: 1 }),
    ])
  ),
]);
